import { observer } from 'mobx-react-lite'
import { DonutChart } from 'shared/ui'
import { useViewPageContext } from 'pages/surveys/pages/view/context/viewContext'
import styles from './styles.module.scss'

export const StatisticsDonutChart = observer(() => {
  const { statisticsChart, statistics, donutChartBarsItems } = useViewPageContext()
  const { nps_score } = statistics
  const title = `${nps_score}`

  return (
    <div className={styles.wrap}>
      <DonutChart
        data={statisticsChart}
        labelProps={{
          title: title,
          desc: 'NPS',
          tooltipProps: {
            label: (
              <>
                NPS (Net Promoter Score) is calculated
                <br />
                by subtracting the percentage of
                <br />
                detractors (0–6) from promoters (9–10),
                <br />
                giving a score between -100 and +100
              </>
            ),
            width: 272,
          },
        }}
        items={donutChartBarsItems}
      />
    </div>
  )
})
